import { createSelector } from 'reselect';
import { alignLeftCellStyle, alignRightCellStyle, alignCenterCellStyle } from '@common/cellStyles';
import { valueGetter, isGroupReportCellEditable, findEditableDataForGroupReport } from '../gridReport/columns/helpers';
import { gridNumeralCellDefinition, gridTextCellDefinition } from '../gridReport/columns/baseDefinitions';

const getColumnDefinitions = editableColumns => [
  {
    headerName: '',
    valueGetter: valueGetter('taxYear'),
    ...gridTextCellDefinition,
    ...alignCenterCellStyle,
    minWidth: 50,
    width: 50,
  },
  {
    headerName: '',
    valueGetter: valueGetter('description'),
    ...gridTextCellDefinition,
    ...alignLeftCellStyle,
    minWidth: 200,
    width: 200,
  },
  {
    headerName: 'Opening',
    valueGetter: valueGetter('OPEN', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('OPEN', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('OPEN', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'FX',
    valueGetter: valueGetter('FX', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('FX', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('FX', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Provision',
    valueGetter: valueGetter('PROV', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('PROV', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('PROV', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Non P&L',
    valueGetter: valueGetter('NON-PL', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('NON-PL', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('NON-PL', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Return to Accrual',
    valueGetter: valueGetter('RTA', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('RTA', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('RTA', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Adjustment',
    valueGetter: valueGetter('ADJ', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('ADJ', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('ADJ', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Payment (Refund)',
    valueGetter: valueGetter('PYMT', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('PYMT', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('PYMT', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Transfer',
    valueGetter: valueGetter('TRAN', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('TRAN', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('TRAN', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Other',
    valueGetter: valueGetter('OTH', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('OTH', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('OTH', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Ending',
    valueGetter: valueGetter('END'),
    editable: isGroupReportCellEditable('END', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('END', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
];

export default createSelector(
  (reportData, isAllowedToMakeDirectEntries, isClientLocked) =>
    (isAllowedToMakeDirectEntries && !isClientLocked && reportData) ? reportData.editableColumns : [],
  editableColumns => getColumnDefinitions(editableColumns)
);
